import { useCallback, useContext, useState } from 'react';
import { FETCH_FAILURES_PER_PAGE_COUNT } from '@bo-constants/resolutions/resolutionDetails';
import { ResolutionDetailsContext } from '@bo-hooks/resolutions/resolutionDetails';
import { useGetResolutionFailuresQuery } from '@bo-services/resolutionsAPI';
import { useParams } from 'react-router-dom';

export const useResolutionFailures = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);

  const { resolutionId = '' } = useParams<{ resolutionId: string }>();

  const handleCurrentPageChange = useCallback(() => {
    setCurrentPage((prevPage) => prevPage + 1);
  }, []);

  const handleResetCurrentPage = useCallback(() => {
    setCurrentPage(1);
  }, []);

  const { resolutionDetails } = useContext(ResolutionDetailsContext);

  const { status } = resolutionDetails;

  const {
    data: response,
    isFetching,
    isError,
    isLoading,
    isSuccess
  } = useGetResolutionFailuresQuery(
    {
      id: resolutionId,
      page: currentPage,
      perPage: FETCH_FAILURES_PER_PAGE_COUNT
    },
    { skip: status !== 'incomplete' }
  );

  const {
    currentPage: currentPageResponse = 0,
    data = [],
    totalPages = 0
  } = response || {};

  const isFailuresFetching = isFetching && currentPage === 1;

  return {
    currentPage: currentPageResponse,
    data,
    handleCurrentPageChange,
    handleResetCurrentPage,
    isError,
    isFetching: isFailuresFetching,
    isLoading,
    isSuccess,
    totalPages
  };
};
